import { API } from "@swivl-mono/api-helper";
import { warn } from "@swivl-mono/helpers";
import { NoteCreatedByType, NoteInterface } from "@swivl-mono/types";
import { create } from "zustand";

import { Member } from "../Member/Member.Current";
import { AlertsModel } from "../Notifications/Alerts.Model";

interface StoreInterface {
  notes: { [userId: number]: NoteInterface[] };
}
const BlankState: StoreInterface = {
  notes: {}
};

export default class NotesModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = NotesModel.useState.setState;
  static get state() {
    return NotesModel.useState.getState();
  }
  static reset() {
    NotesModel.setState({ ...BlankState });
  }

  static async loadForUser(userId: number, includeArchived: boolean = true) {
    API.Notes.getNotesForUser(Member.orgId, userId, includeArchived)
      .then((usersNotes) => {
        console.log("usersNotes :", usersNotes);
        const notes = { ...NotesModel.state.notes };
        notes[userId] = usersNotes;
        NotesModel.setState({ notes });
      })
      .catch((error) => {
        warn("Error loading user notes", error);
        AlertsModel.errorToast("Error loading user notes");
      });
  }

  static async createNoteForUser(userId: number, content: string) {
    const newNote: Omit<NoteInterface, "createdAt" | "updatedAt" | "id"> = {
      content,
      archived: false,
      pinned: true,
      orgId: Member.orgId,
      userId,
      createdBy: { creator: NoteCreatedByType.Member, memberId: Member.id }
    };
    API.Notes.createOrUpdateNote(Member.orgId, userId, false, newNote)
      .then((createdNote) => {
        console.log("createdNote :", createdNote);
        const notes = { ...NotesModel.state.notes };
        const userNotes = [...(notes[userId] || [])];
        userNotes.unshift(createdNote);
        notes[userId] = userNotes;
        NotesModel.setState({ notes });
        AlertsModel.successToast("Note created successfully");
      })
      .catch((error) => {
        warn("Error creating note", error);
        AlertsModel.errorToast("Error creating note");
      });
  }

  static async setArchivedForNote(userId: number, noteId: number, archived: boolean) {
    const userNotes = NotesModel.state.notes[userId] || [];
    const note = userNotes.find((n) => n.id === noteId);
    if (!note) {
      warn("Note not found to archive :", noteId);
      AlertsModel.errorToast("Note not found to archive");
      return;
    }
    const updatedNote = { ...note, archived };
    API.Notes.updateNote(noteId, updatedNote)
      .then((updatedNote) => {
        console.log("updatedNote :", updatedNote);
      })
      .catch((error) => {
        warn("Error archiving note", error);
        AlertsModel.errorToast("Error archiving note");
      });
  }

  static async setPinnedForNote(userId: number, noteId: number, pinned: boolean) {
    API.Notes.updateNote(noteId, { pinned })
      .then((updatedNote) => {
        const notes = { ...NotesModel.state.notes };

        const userNotes = [...(notes[userId] || [])];

        const updated = userNotes.map((n) => (n.id === noteId ? updatedNote : n));
        notes[userId] = updated;
        NotesModel.setState({ notes });
      })
      .catch((error) => {
        warn("Error pinning note", error);
        AlertsModel.errorToast("Error pinning note");
      });
  }
}
